<template>
  <div class="app-con">
    <head-nav :user="user" :salers="salers" :headNode="headNode" @updateUser="updateUser" @showChat="showChat"></head-nav>
    <left-menu :user="user" :menus="menus"></left-menu>
    <!-- <set-consult-target v-if="dialogVisible2" :date2="date2"></set-consult-target>
    <set-flag v-if="dialogVisible" :date1="date1" :leftAlert="leftAlert"></set-flag> -->
    <div class="app-con-c">
      <router-view :user="user" :style="collapse ? foldStyle : unFoldStyle" @updateUser="updateUser" />
    </div>
    <dialpad></dialpad>
<!--    <right-sidebar></right-sidebar>-->
    <im />
  </div>
</template>

<script>
import HeadNav from 'common/HeadNav'
import LeftMenu from 'common/LeftMenu'
import SetConsultTarget from 'common/SetConsultTarget'
import SetFlag from 'common/SetFlag'
import Dialpad from 'common/Dialpad'
import RightSidebar from 'common/RightSidebar'
import Im from 'common/im/Im'
// import generateAsyncComponents from '../../lib/AsyncComponents.js'
export default {
  name: 'Base',
  components: {
    SetConsultTarget,
    SetFlag,
    HeadNav,
    LeftMenu,
    Dialpad,
    RightSidebar,
    Im
  },
  data () {
    return {
      salers: [],
      headNode: [],
      user: {},
      menus: [],
      date1: '',
      date2: '',
      dialogVisible: false,
      dialogVisible2: false,
      leftAlert: [],
      status: false,
      isCollapse: true,
      foldStyle:{
        marginLeft: '1.25rem',
        width: '-webkit-fill-available'
      },
      unFoldStyle:{
        marginLeft: '3.6rem',
        width: '-webkit-fill-available'
      },
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    },
    userStore () {
      return this.$store.state.userStore
    }
  },
  watch: {
    userStore: {
      handler (newVal, oldVal) {
        this.user = newVal
      },
      deep: true
    }
  },
  methods: {
    handleStatus () {
      this.$axios.get('/api/target/status')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.dialogVisible = data.data.status ? this.status : true
            this.leftAlert = data.data.leftString
            this.date1 = data.data.date
          }
        })
    },
    handleConsultStatus () {
      this.$axios.get('/api/target/consult_status')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.dialogVisible2 = data.data.status ? this.status : true
            this.date2 = data.data.date2
            // this.handleStatus()
          }
        })
    },
    getUserInfo () {
      this.$axios.get('/api/admin/user')
        .then(this.handleGetUserSucc)
    },
    handleGetUserSucc (res) {
      res = res.data
      if (res.code === 0) {
        this.user = res.data.user
        this.menus = res.data.menus
        this.$store.dispatch('createUserStoreAction', this.user)
        if (res.data.menuState === 0) {
          this.isCollapse = true
        } else {
          this.isCollapse = false
        }
        this.$store.dispatch('setCollapse', this.isCollapse)
      }
    },
    updateUser (updatedUser) {
      if (this.user.id === updatedUser.id) {
        this.user = updatedUser
      }
    },
    getCallToken () {
      this.$axios.get('/api/admin/auth/callToken')
        .then((res) => {
          const { data } = res
          if (data.code === 200) {
            let callToken = {
              expired: data.data.expired,
              token: data.data.token
            }
            localStorage.callToken = JSON.stringify(callToken)
            this.callInit()
          }
        })
    },
    refreshToken () {
      let token = localStorage.callToken
      let callToken = JSON.parse(token)
      let date = parseInt(new Date().getTime() / 1000)

      if (date >= callToken.expired) {
        this.$axios.get('/api/admin/auth/callToken')
          .then((res) => {
            const { data } = res
            if (data.code === 200) {
              localStorage.removeItem('callToken')
              let callToken = {
                expired: data.data.expired,
                token: data.data.token
              }
              localStorage.callToken = JSON.stringify(callToken)
            }
          })
      }
    },
    callInit () {
      window.CallClient.init({
        getToken: () => {
          let token = localStorage.callToken
          let callToken = JSON.parse(token)
          this.refreshToken()
          return callToken.token
        }
      })
    },
    getSalers () {
      this.$axios.get('/api/admin/users')
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.salers = data.data.users
            this.headNode = data.data.pageNodes
          }
        })
    },
    showChat (val) {
      this.$store.dispatch('showImWindowStoreAction', !this.$store.state.imVisible)
    }
  },
  mounted () {
    this.getUserInfo()
    // this.handleStatus()
    this.handleConsultStatus()
    this.getSalers()
    // this.getCallToken()
  },
  beforeDestroy () {
    console.log('beforeDestroy')
  }
}
</script>

<style>
  .app-con {
    display: flex;
    justify-content: space-between;
  }
  .app-con-c {
    flex: auto;
    overflow-x: auto;
  }
  .v-modal {
    position: sticky;
  }
</style>



// WEBPACK FOOTER //
// src/pages/base/Base.vue